import { useEffect, useState } from "react";

import authorImage from "../../assets/Asman_PIc-Copy.jpeg";

import sqlInjectionMainImage from "../../assets/blog_images/sqlInjection/sqlInjection2.png";
import sqlTypesImage from "../../assets/blog_images/sqlInjection/sqlTypes.png";
import example1Image from "../../assets/blog_images/sqlInjection/example1.png";
import example2Image from "../../assets/blog_images/sqlInjection/example2.png";

import sqlInjectionCardImage from "../../assets/blog_images/sqlInjection/sql_injection1.jpg";
import brokenAccessImage from "../../assets/blog_images/BrokenAccessControllAuthentication/brokenThumbnail.png";
import sessionImage from "../../assets/blog_images/sessionManagement/session1.png";

const SUPPORT_WHATSAPP_NUMBER = "919080432374";
const SUPPORT_MESSAGE = "Hi, I am Looking for Cyber Security Training";

function SqlInjection() {
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [whatsappOpen, setWhatsappOpen] = useState(false);
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    document.title = "SQL Injection";

    function handleScroll() {
      setShowBackToTop(window.scrollY > 300);
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function openWhatsAppChat() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const waMe = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;

    window.open(waMe, "_blank", "noopener,noreferrer");
  }

  function openWhatsAppAppFallback() {
    const encoded = encodeURIComponent(SUPPORT_MESSAGE);
    const deepLink = `whatsapp://send?phone=${SUPPORT_WHATSAPP_NUMBER}&text=${encoded}`;
    const webLink = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encoded}`;

    window.location.href = deepLink;

    setTimeout(() => {
      window.open(webLink, "_blank", "noopener,noreferrer");
    }, 700);
  }

  return (
    <main className="overflow-x-hidden bg-white">
      <section className="w-full max-w-5xl px-4 py-10 mx-auto overflow-x-hidden bg-white">
        <article className="article post tag-hackthebox image-small">
          <header className="article-header gh-canvas">
            <div className="mb-2 article-tag post-card-tags">
              <span className="post-card-primary-tag">
                <a href="" className="text-blue-600">
                  WebApplicationSecurity
                </a>
              </span>
            </div>

            <h1 className="mb-4 text-4xl font-semibold article-title">
              Understanding SQL Injection: A Web Security Threat
            </h1>

            <p className="mb-6 text-gray-800 article-excerpt">
              SQL Injection is a serious web security flaw that lets attackers
              manipulate SQL queries to access or alter database data. It can
              lead to data breaches, loss, or full database control if not
              properly prevented. Let's get started!
            </p>

            {/* Article Author Info */}
            <div className="flex flex-col items-start justify-between mb-6 sm:flex-row sm:items-center">
              {/* Left Section */}
              <div className="flex items-start gap-4">
                <img
                  className="w-12 h-12 rounded-full"
                  src={authorImage}
                  alt="Asman"
                />

                <div>
                  <h4 className="text-lg font-semibold">
                    <a href="">Asman</a>
                  </h4>

                  <div className="text-sm font-medium text-gray-500">
                    <time dateTime="2025-05-03">May 03, 2025</time>
                    <span className="ml-1">• 7 min read</span>
                  </div>
                </div>
              </div>

              {/* Right Section: Share Icon */}
              <button
                type="button"
                onClick={() => setShareModalOpen(true)}
                className="mt-5 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
              >
                {/* Share Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-8 h-8 fill-current"
                  viewBox="0 0 24 24"
                >
                  <path
                    fillRule="evenodd"
                    d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
                    clipRule="evenodd"
                  ></path>
                </svg>
              </button>
            </div>

            {/* Share Modal */}
            {shareModalOpen && (
              <div
                className="fixed inset-0 z-50 flex items-center justify-center bg-opacity-50"
                onClick={(event) => {
                  if (event.target === event.currentTarget) {
                    setShareModalOpen(false);
                  }
                }}
              >
                <div className="p-6 text-black bg-gray-200 rounded-md w-80">
                  <h2 className="mb-4 text-lg font-semibold">
                    Share this article
                  </h2>

                  <div className="flex items-center justify-around">
                    {/* X / Twitter */}
                    <a
                      href="https://twitter.com/intent/tweet?text=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-500"
                    >
                      <svg className="w-10 h-10 fill-current" viewBox="0 0 24 24">
                        <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53A4.48 4.48 0 0 0 22.43.36a9 9 0 0 1-2.83 1.08A4.52 4.52 0 0 0 16.11 0c-2.63 0-4.64 2.24-4.04 4.79A12.94 12.94 0 0 1 1.64 1.14a4.52 4.52 0 0 0-.61 2.27 4.5 4.5 0 0 0 2 3.75 4.41 4.41 0 0 1-2.06-.56v.06a4.53 4.53 0 0 0 3.63 4.43 4.52 4.52 0 0 1-2.04.08 4.53 4.53 0 0 0 4.22 3.14A9.05 9.05 0 0 1 0 19.54a12.93 12.93 0 0 0 7 2.05c8.4 0 13-7.5 12.68-14.23A9.18 9.18 0 0 0 23 3z" />
                      </svg>
                    </a>

                    {/* Facebook */}
                    <a
                      href="https://www.facebook.com/sharer/sharer.php?u=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-700"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M22.675 0h-21.35C.592 0 0 .593 0 1.326v21.348C0 23.408.592 24 1.325 24H12.82V14.708h-3.293V11.17h3.293V8.413c0-3.26 1.986-5.038 4.89-5.038 1.39 0 2.585.104 2.933.15v3.4l-2.013.001c-1.577 0-1.883.75-1.883 1.85v2.43h3.766l-.491 3.538h-3.275V24h6.42C23.408 24 24 23.408 24 22.675V1.325C24 .593 23.408 0 22.675 0z" />
                      </svg>
                    </a>

                    {/* LinkedIn */}
                    <a
                      href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.practicalinfosec.com/sqlInjection"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hover:text-blue-600"
                    >
                      <svg className="w-8 h-8 fill-current" viewBox="0 0 24 24">
                        <path d="M20.447 20.452H17.24V14.8c0-1.345-.025-3.078-1.879-3.078-1.88 0-2.168 1.464-2.168 2.976v5.753h-3.207V9h3.076v1.561h.043c.429-.811 1.476-1.666 3.036-1.666 3.246 0 3.844 2.137 3.844 4.917v6.64zM5.337 7.433c-1.034 0-1.873-.839-1.873-1.874 0-1.034.839-1.873 1.873-1.873 1.036 0 1.875.839 1.875 1.873s-.839 1.874-1.875 1.874zM6.789 20.452H3.885V9h2.904v11.452zM22.225 0H1.771C.791 0 0 .77 0 1.723v20.555C0 23.23.79 24 1.771 24h20.451C23.21 24 24 23.23 24 22.278V1.723C24 .77 23.21 0 22.225 0z" />
                      </svg>
                    </a>
                  </div>

                  <button
                    type="button"
                    onClick={() => setShareModalOpen(false)}
                    className="block mx-auto mt-4 text-sm text-gray-600 underline hover:text-black"
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            <figure className="mb-6 article-image">
              <img
                src={sqlInjectionMainImage}
                alt="Sql Injection"
                className="w-full rounded-lg"
              />
            </figure>
          </header>

          <section className="gh-content gh-canvas">
            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Understanding SQL Injection
            </h2>

            <p className="mb-4">
              SQL injection involves exploiting input fields in a web application
              to execute unauthorized SQL commands. When an application fails to
              properly validate or sanitize user input before building SQL
              queries, attackers can inject malicious SQL code. This can lead to
              unauthorized access, data exfiltration, modification, or even
              deletion of entire datasets—ultimately allowing the attacker to
              manipulate the database in unintended and potentially damaging
              ways.
            </p>

            <p className="mb-4">
              SQL injection occurs when an attacker inserts malicious SQL code
              into input fields of a web application—such as search boxes, login
              forms, or contact pages. This vulnerability poses a serious threat,
              as it can lead to the theft of sensitive data, unauthorized access,
              and even full system compromise. It remains a common and dangerous
              attack vector, consistently ranking among the top threats in
              OWASP’s Top 10 Application Security Risks, where SQL injection is
              listed as the second most critical vulnerability.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              What is SQL queries in a database?
            </h2>

            <p className="mb-4">
              SQL (Structured Query Language) is the standard programming
              language used for managing and manipulating data in a Relational
              Database Management System (RDBMS) or in stream processing within a
              Relational Data Stream Management System (RDSMS). Put, SQL is a
              declarative language that enables users to store, retrieve, update,
              delete, and manage data in relational databases.
            </p>

            <p className="mb-4">
              SQL queries are structured commands written in SQL to interact with
              databases. They allow users to perform a wide variety of
              operations, including retrieving specific records, modifying
              existing data, adding new entries, or removing outdated ones.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              Some key functions SQL queries can perform include:
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6">Retrieving data from a database</li>
              <li className="ml-6">Inserting, updating, or deleting records</li>
              <li className="ml-6">Creating new databases and tables</li>
              <li className="ml-6">Defining stored procedures and views</li>
              <li className="ml-6">
                Setting user permissions on tables, views, and procedures
              </li>
            </ul>

            <p className="mt-4 mb-4">
              SQL commands are typically structured as statements and can be
              combined into full programs or scripts to carry out complex
              operations on data.
            </p>

            <h2 id="network-scan" className="mb-4 text-3xl font-semibold">
              A few basic examples of SQL queries include:
            </h2>

            <pre className="p-4 overflow-x-auto bg-gray-100 rounded-lg">
              <code className="text-sm text-gray-800 whitespace-pre-wrap">
{`SELECT: Intended to retrieve data from tables.
SELECT column1, column2 FROM tablename WHERE condition;

INSERT INTO: Intended to insert new data into a table.
INSERT INTO tablename (column1, column2) VALUES (value1, value2);

UPDATE: Intended to modify existing data in a table.
UPDATE tablename SET column1=value1 WHERE condition;`}
              </code>
            </pre>

            <h2 id="network-scan" className="mt-4 mb-4 text-3xl font-semibold">
              Different types of SQL injection
            </h2>

            <figure className="mb-6 article-image">
              <img
                src={sqlTypesImage}
                alt="Sql Injection"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-2 text-xl font-semibold">
              1.In-Band SQLi:
            </h2>

            <p className="mb-4">
              The attackers use the same communication channel to launch their
              attacks and collect results.
            </p>

            <h2 id="network-scan" className="mb-2 text-xl font-semibold">
              Error Based
            </h2>

            <p className="mb-4">
              Error-based SQL injection is a type of SQL injection attack where
              the attacker exploits error messages generated by the database
              server to gather information about the structure of the database or
              to extract data.
            </p>

            <h2 id="network-scan" className="mb-2 text-xl font-semibold">
              Example :
            </h2>

            <figure className="mb-6 article-image">
              <img
                src={example1Image}
                alt="Sql Injection"
                className="w-full rounded-lg"
              />
            </figure>

            <p className="mb-4">
              The error is dependent upon the kind of database used in the
              backend, given below is an example.
            </p>

            <figure className="mb-6 article-image">
              <img
                src={example2Image}
                alt="Sql Injection"
                className="w-full rounded-lg"
              />
            </figure>

            <h2 id="network-scan" className="mb-2 text-xl font-semibold">
              Union Based
            </h2>

            <p className="mb-4">
              In this technique, the UNION SQL operator is used to combine the
              results of two or more SELECT statements into a single HTTP
              response. Attackers can craft these queries directly within the URL
              or input fields to manipulate the query and retrieve additional
              data from the database.
            </p>

            <h2 id="network-scan" className="mb-2 text-xl font-semibold">
              Example
            </h2>

            <h2 id="network-scan" className="mb-2 text-xl font-semibold">
              Steps to exploit Union Based SQL Injection
            </h2>

            <ul className="space-y-2 text-gray-800 list-inside">
              <li className="ml-6">
                1. Determine number of columns that the query is making while
                supplying user input
              </li>
              <li className="ml-6">
                2. Figure out the data types of the columns string datatype is
                common and helpful
              </li>
              <li className="ml-6">
                3. Utilize UNION operator to extract sensitive information from
                the database
              </li>
              <li className="ml-6">Defining stored procedures and views</li>
              <li className="mb-4 ml-6">
                Setting user permissions on tables, views, and procedures
              </li>
            </ul>

            <pre className="p-4 overflow-x-auto bg-gray-100 rounded-lg">
              <code className="text-lg text-gray-800 whitespace-pre-wrap">
{`https://example.com/products?id=1
https://example.com/products?id=1' order by 1--
https://example.com/products?id=1' order by 2--
https://example.com/products?id=1' order by 3-- #  Got error here
https://example.com/products?id=1' UNION SELECT 'a', NULL--
https://example.com/products?id=1' UNION SELECT NULL, 'a'--
https://example.com/products?id=1' UNION SELECT email,pass from users--`}
              </code>
            </pre>

            <h2 id="network-scan" className="mt-4 mb-2 text-xl font-semibold">
              2.Blind SQL Injection:
            </h2>

            <p className="mb-4">
              Here, it does not transfer the data via the web application. The
              attacker can not see the result of an attack in-band.
            </p>

            <h2 id="network-scan" className="mb-2 text-xl font-semibold">
              Boolean Based
            </h2>

            <p className="mb-4">
              In this method, the attacker sends SQL queries that trigger
              different responses based on whether the query evaluates to true or
              false. By observing the application's behavior, the attacker can
              infer information about the database.
            </p>

            <h2 id="network-scan" className="mb-2 text-xl font-semibold">
              Example :
            </h2>

            <pre className="p-4 overflow-x-auto bg-gray-100 rounded-lg">
              <code className="text-lg text-gray-800 whitespace-pre-wrap">
{`https://example.com/products?name=laptop' AND 1=1
https://example.com/products?name=laptop' AND 1=2`}
              </code>
            </pre>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Time-based SQL Injection :
            </h2>

            <p className="mb-4">
              In this technique, the attacker sends SQL queries that cause the
              database to delay its response by a specific amount of time if a
              condition is true. The attacker then uses the delay or lack thereof
              to determine whether the injected condition is true or false,
              helping to extract information from the database without visible
              output.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mb-4 text-2xl font-semibold"
            >
              Example:
            </h2>

            <pre className="p-4 overflow-x-auto bg-gray-100 rounded-lg">
              <code className="text-lg text-gray-800 whitespace-pre-wrap">
{`MySQL: SELECT SLEEP(10)
Microsoft: WAITFOR DELAY '0:0:10'
Oracle: dbms_pipe.receive_message(('a'),10)
PostgreSQL: SELECT pg_sleep(10)`}
              </code>
            </pre>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              3. SQL Injection — Out-of-Band
            </h2>

            <p className="mb-4">
              Out-of-band SQL injection is a type of SQL injection attack that
              leverages alternative communication channels to exfiltrate data
              from the target database when direct retrieval through the
              application’s response is not feasible. This method is particularly
              useful when traditional SQL injection techniques, such as
              error-based or time-based attacks, are not effective due to
              restrictions in the environment or countermeasures implemented by
              the defender.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Most Common Payloads of SQL injection
            </h2>

            <ul className="space-y-2 text-gray-800 list-disc list-inside">
              <li className="ml-6">' OR 1=1 --</li>
              <li className="ml-6">' OR '1'='1' --</li>
              <li className="ml-6">admin' -- </li>
              <li className="ml-6">' OR 1=1#</li>
            </ul>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Impacts of SQL Injection
            </h2>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Database Enumeration
            </h2>

            <p className="mb-4">
              Attackers can discover details about the database structure, such
              as table names, column names, and data types. This is often done
              using error messages or blind injection techniques like time delays
              or Boolean logic.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Privilege Escalation
            </h2>

            <p className="mb-4">
              If user role data is exposed, attackers can identify
              high-privilege accounts like database admins or application
              superusers. This can lead to elevated access, allowing further
              compromise of the system.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Stealing credentials:
            </h2>

            <p className="mb-4">
              SQL injections can be used to obtain users’ credentials. Attackers
              can access their privileges then pose as these users.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Accessing database:
            </h2>

            <p className="mb-4">
              Attackers can use SQL injections to reach information stored in a
              database server.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Altering data:
            </h2>

            <p className="mb-4">
              Attackers can use SQL injections to modify or destroy the accessed
              database.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Accessing networks:
            </h2>

            <p className="mb-4">
              Attackers can use SQL injections to reach information stored in a
              database server.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Accessing database:
            </h2>

            <p className="mb-4">
              Attackers can use SQL injections to access database servers with
              operating system privileges. Then, the attacker can try to access
              the network.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-3xl font-semibold"
            >
              Prevention for SQL Injection
            </h2>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Use Parameterized Queries:
            </h2>

            <p className="mb-4">
              Separate SQL logic from user input to prevent malicious code
              injection.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Validate Input:
            </h2>

            <p className="mb-4">
              Ensure all user input is checked for expected format and type
              before processing.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Escape User Input:
            </h2>

            <p className="mb-4">
              Properly encode special characters to neutralize potentially
              harmful input.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Limit Database Privileges:
            </h2>

            <p className="mb-4">
              Grant only necessary permissions to reduce impact if a breach
              occurs.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Avoid Shared Database Accounts:
            </h2>

            <p className="mb-4">
              Use unique, restricted accounts for each application or website.
            </p>

            <h2
              id="web-enumeration-and-user-shell"
              className="mt-4 mb-4 text-2xl font-semibold"
            >
              Keep Software Updated:
            </h2>

            <p>
              Apply security patches regularly to close known vulnerabilities.
            </p>
          </section>
        </article>
      </section>

      {/* Right Section: Share Icon */}
      <section className="w-full max-w-5xl px-4 mx-auto">
        <button
          type="button"
          onClick={() => setShareModalOpen(true)}
          className="mt-10 ml-2 text-2xl text-gray-700 cursor-pointer font-bild hover:text-black"
        >
          {/* Share Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8 fill-current"
            viewBox="0 0 24 24"
          >
            <path
              fillRule="evenodd"
              d="M15.218 4.931a.4.4 0 0 1-.118.132l.012.006a.45.45 0 0 1-.292.074.5.5 0 0 1-.3-.13l-2.02-2.02v7.07c0 .28-.23.5-.5.5s-.5-.22-.5-.5v-7.04l-2 2a.45.45 0 0 1-.57.04h-.02a.4.4 0 0 1-.16-.3.4.4 0 0 1 .1-.32l2.8-2.8a.5.5 0 0 1 .7 0l2.8 2.79a.42.42 0 0 1 .068.498m-.106.138.008.004v-.01zM16 7.063h1.5a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-11c-1.1 0-2-.9-2-2v-10a2 2 0 0 1 2-2H8a.5.5 0 0 1 .35.15.5.5 0 0 1 .15.35.5.5 0 0 1-.15.35.5.5 0 0 1-.35.15H6.4c-.5 0-.9.4-.9.9v10.2a.9.9 0 0 0 .9.9h11.2c.5 0 .9-.4.9-.9v-10.2c0-.5-.4-.9-.9-.9H16a.5.5 0 0 1 0-1"
              clipRule="evenodd"
            ></path>
          </svg>
        </button>
      </section>

      {/* Author Section */}
      <section className="max-w-5xl px-4 py-6 mx-auto mt-10 overflow-x-hidden rounded-lg">
        <div className="flex flex-col items-start gap-6 sm:flex-row">
          {/* Author Image */}
          <img
            src={authorImage}
            alt="Asman"
            className="object-cover w-24 h-24 rounded-lg"
          />

          {/* Author Info */}
          <div>
            <h3 className="mb-2 text-2xl font-semibold">Written by Asman</h3>

            <p className="mb-3 text-gray-700">Offensive Security Researcher.</p>

            <p className="text-gray-500 text-md">
              Published on <time dateTime="2023-02-11">May 03, 2025</time> • 7
              min read
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 text-black bg-white">
        <div className="max-w-screen-xl px-4 mx-auto sm:px-4 lg:px-8">
          <div className="grid grid-cols-1 gap-6 sm:gap-8 sm:grid-cols-2 lg:grid-cols-3">
            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a href="sql-injection" target="_blank" rel="noopener noreferrer">
                  <img
                    className="object-cover w-full h-48"
                    src={sqlInjectionCardImage}
                    alt="SQL Injection"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Understanding SQL Injection: A Web Security Threat
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    SQL Injection is a critical security flaw that allows
                    attackers to manipulate SQL queries, risking data breaches or
                    full database control.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 03, 2025</span>
                    <span>7 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 2 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="OWASPTop10"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="broken-access-control-authentication"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={brokenAccessImage}
                    alt="Broken Access Control Authentication"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">OWASPTop10</div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Broken Access Control & Auth: A Security Breakdown
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Broken Access Control and Authentication vulnerabilities are
                    critical security flaws that allow unauthorized users to gain
                    access to restricted areas.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>May 02, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Blog Card 1 */}
            <article
              className="transition duration-300 ease-in-out transform blog-card"
              data-category="WebApplicationSecurity"
            >
              <div className="overflow-hidden transition bg-gray-100 shadow rounded-xl hover:shadow-lg">
                <a
                  href="session-management"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="object-cover w-full h-48"
                    src={sessionImage}
                    alt="Session Management"
                  />
                </a>

                <div className="p-5">
                  <div className="mb-2 text-sm text-black">
                    WebApplicationSecurity
                  </div>

                  <h3 className="mb-2 text-xl font-semibold">
                    Secure Session Management: Best Practices & Techniques
                  </h3>

                  <p className="mb-4 text-sm text-black">
                    Session management is secure for user authentication in web
                    applications. Techniques to prevent session-related threats
                    like hijacking and fixation.
                  </p>

                  <div className="flex justify-between text-sm font-semibold text-gray-700">
                    <span>Apr 28, 2025</span>
                    <span>5 min read</span>
                  </div>
                </div>
              </div>
            </article>

            {/* Repeat your blog cards here (already responsive) */}
          </div>
        </div>
      </section>

      {/* WhatsApp Sticky Button */}
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
          setWhatsappOpen((prev) => !prev);
        }}
        className="fixed z-50 p-3 px-4 text-white transition -translate-y-1/2 rounded-full shadow-lg cursor-pointer top-1/2 right-6 animate-blink hover:opacity-90 bg-gradient-to-r from-green-400 via-green-500 to-green-600"
        aria-label="Join WhatsApp"
      >
        <i className="text-4xl fa-brands fa-whatsapp"></i>
      </button>

      {/* WhatsApp Modal */}
      {whatsappOpen && (
        <div
          className="fixed z-50 p-4 transition-opacity duration-300 -translate-y-1/2 bg-white shadow-xl top-1/2 right-20 rounded-xl w-72 max-sm:right-4 max-sm:left-4 max-sm:w-auto"
          role="dialog"
          aria-modal="true"
          aria-labelledby="whatsappTitle"
        >
          {/* Close Button */}
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              setWhatsappOpen(false);
            }}
            className="absolute text-3xl text-gray-600 cursor-pointer top-2 left-4 hover:text-red-500"
            aria-label="Close"
          >
            &times;
          </button>

          <h2
            id="whatsappTitle"
            className="mt-6 mb-2 text-lg font-bold text-center text-gray-800"
          >
            Unsure about which course to choose?
          </h2>

          <p className="mb-3 text-sm text-center text-gray-700">
            Tap below to start a WhatsApp chat — we're here to help!
          </p>

          {/* Action buttons */}
          <div className="flex flex-col items-center gap-3">
            <button
              type="button"
              onClick={openWhatsAppChat}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-white transition bg-green-600 rounded-full hover:bg-green-700"
              aria-label="Chat Now on WhatsApp"
            >
              <i className="fa-brands fa-whatsapp"></i>
              Chat Now
            </button>

            <button
              type="button"
              onClick={openWhatsAppAppFallback}
              className="inline-flex items-center justify-center w-full gap-2 px-3 py-2 text-sm text-gray-800 transition border border-gray-200 rounded-full hover:bg-gray-50"
              aria-label="Open in WhatsApp App"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 text-green-600"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M20.52 3.48A11.93 11.93 0 0012 .5C5.73.5.99 5.24.99 11.5c0 2.01.53 3.95 1.53 5.68L0 24l6.97-1.79c1.61.45 3.28.68 4.9.68 6.27 0 11.01-4.74 11.01-11 0-3.02-1.18-5.85-3.36-7.41zM12 21.5c-1.44 0-2.86-.34-4.14-.99l-.3-.15-4.14 1.06 1.15-3.98-.18-.31A8.12 8.12 0 013 11.5c0-4.97 4.06-9 9-9 2.41 0 4.66.94 6.36 2.64a8.95 8.95 0 012.64 6.36c0 4.97-4.06 9-9 9z" />
              </svg>
              Open in App
            </button>
          </div>
        </div>
      )}

      {/* Back to Top Button */}
      {showBackToTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed z-50 p-4 text-white transition bg-blue-700 rounded-lg shadow-lg cursor-pointer bottom-12 right-7 hover:bg-blue-700"
          aria-label="Back to top"
        >
          <i className="text-xl fa-solid fa-arrow-up"></i>
        </button>
      )}

      {/* Floating Call Button */}
      <a
        href="tel:+91-9080432374"
        className="fixed z-50 p-3 text-white transition rounded-md shadow-lg cursor-pointer bg-violet-600 bottom-60 right-7 hover:bg-green-700"
        aria-label="Call Us"
      >
        <i className="text-2xl fa-solid fa-phone"></i>
      </a>
    </main>
  );
}

export default SqlInjection;